import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class VlibrasService {

    constructor() { }

    public showVlibras() {
        if (document.getElementsByClassName('vlibras-hidden').length > 0) {
            const vlibras = document.getElementsByClassName('vlibras-hidden')[0];
            vlibras.classList.remove('vlibras-hidden');
        }
    }
}
